module.exports = __webpack_public_path__ + "img/gp.c2c4da0e.svg";